import React from 'react';
import './ContactSection.css';

function ContactSection() {
    return (
        <section id="contact" className="contact">
            <h2 className="contact__title">Contáctanos</h2>
            <p className="contact__text">
                Para reservas, consultas y cursos, contáctanos por WhatsApp:
            </p>
            <ul className="contact__list">
                <li><strong>Curso AFF y Saltos Tándem:</strong> WhatsApp <a href="https://wa.me/59898604727">098 604 727</a></li>
                <li><strong>Curso Línea Estática:</strong> WhatsApp <a href="https://wa.me/59896008662">096 008 662</a></li>
            </ul>
        </section>
    );
}

export default ContactSection;
